import type { TrainingPlanItem } from './trainingSession';

/** Elérhető-e most az AI a bejelentkezett felhasználónak. */
export interface AiStatus {
  available: boolean;
  model: string | null;
  remainingToday: number;
  /** A dokumentumból kitöltés engedélyezett-e (személyes adatot küld). */
  personalDataAllowed: boolean;
}

export interface AiUsageByFeature {
  feature: string;
  count: number;
  failed: number;
}

export interface AiSettings {
  enabled: boolean;
  model: string | null;
  dailyLimit: number;
  userDailyLimit: number;
  allowPersonalData: boolean;
  /** Be van-e állítva az OpenRouter API kulcs a szerveren. */
  apiKeyConfigured: boolean;
  usedToday: number;
  usageLast30Days: AiUsageByFeature[];
}

export interface UpdateAiSettingsRequest {
  enabled: boolean;
  model: string | null;
  dailyLimit: number;
  userDailyLimit: number;
  allowPersonalData: boolean;
}

export interface AiModelOption {
  id: string;
  name: string;
  isFree: boolean;
  contextLength?: number | null;
  supportsImages: boolean;
  /** Dollár / millió token. */
  promptPricePerMillion?: number | null;
  completionPricePerMillion?: number | null;
}

export interface AiTestResult {
  model: string;
  reply: string;
  elapsedMs: number;
}

export interface AiTextResult {
  content: string;
}

export interface AiTrainingPlanRequest {
  ageGroupId?: number | null;
  durationMinutes: number;
  topic: string;
  playerCount?: number | null;
  notes?: string | null;
  useDrillLibrary: boolean;
}

export interface AiTrainingPlanResult {
  goal?: string | null;
  items: TrainingPlanItem[];
  fromLibraryCount: number;
}

export type AiAnnouncementTone = 'friendly' | 'formal' | 'short';

export interface AiAnnouncementRequest {
  notes: string;
  tone: AiAnnouncementTone;
  eventId?: number | null;
  currentText?: string | null;
}

export type AiMatchSummaryStyle = 'parents' | 'social' | 'report';
export type AiNameStyle = 'full' | 'first' | 'none';

export interface AiMatchSummaryRequest {
  style: AiMatchSummaryStyle;
  nameStyle: AiNameStyle;
  coachNotes?: string | null;
}

export interface AiCoachSummaryRequest {
  ageGroupId?: number | null;
  days: number;
}

export interface AiPlayerEvaluationRequest {
  dateFrom?: string | null;
  dateTo?: string | null;
  coachNotes?: string | null;
  audience: 'parents' | 'internal';
}

export interface AiAskResult {
  queryTitle?: string | null;
  answer: string;
  columns: string[];
  rows: string[][];
}

export interface AiExtractedPlayer {
  name?: string | null;
  birth?: string | null;
  gender?: string | null;
  placeOfBirth?: string | null;
  countryOfBirth?: string | null;
  citizen?: string | null;
  mothersName?: string | null;
  taj?: string | null;
  address?: string | null;
  phone?: string | null;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  emergencyContactRelation?: string | null;
  warnings: string[];
}

/** A funkciók kódjai a használati statisztikához (backend: AiFeatures). */
export const AI_FEATURE_LABELS: Record<string, string> = {
  'training-plan': 'Edzésterv',
  diagram: 'Rajz szövegből',
  announcement: 'Bejelentés',
  'match-summary': 'Mérkőzés-beszámoló',
  'coach-summary': 'Heti összefoglaló',
  'player-evaluation': 'Játékos-értékelés',
  ask: 'Kérdezz az adatokról',
  'extract-player': 'Kitöltés dokumentumból',
};
